import { Component, OnInit } from '@angular/core';
import { StateService, Transition, TransitionService } from '@uirouter/core';

@Component({
  selector: 'app-function-unavailable',
  templateUrl: './function-unavailable.component.html',
  styleUrls: ['./function-unavailable.component.scss']
})
export class FunctionUnavailableComponent implements OnInit {
  heading: string = "";
  paragraph1: string = "";
  paragraph2: string = "";
  paragraph3: string = "";


  constructor(
    public stateService: StateService,
    public transitionService: TransitionService,
    public transition: Transition
  ) { }

  ngOnInit(): void {
    const module = this.transition.params().module;
    const action = this.transition.params().function;
    const reason = this.transition.params().reason;

    if (reason == "mobile") {
      this.heading = `This Feature is not Available on Mobile Phones and Small Screens`
      if (module == "search" && action == "projects") {

        this.paragraph1 = `Full criteria searching for projects is not available on mobile phones or very narrow devices`;
        this.paragraph2 = `You can still access and use your saved searches`;
        this.paragraph3 = `You can learn more about the features available on mobile devices in the <a href="https://eicdsuserguide.the-eic.com/intro">user guide</a>`;
      }
      if (module == "search" && action == "contractawards") {
        this.paragraph1 = `Full criteria searching for projects is not available on mobile phones or very narrow devices`;
        this.paragraph2 = `You can learn more about the features available on mobile devices in the <a href=">user guide</a>`;
        this.paragraph3 = "";
      }
    }

    console.log("the transition parameters were:", module, action, reason)
  }

}
